<template>
    <div class="model-wrap player">
        <div class="info-title">
            <span class="icon icon-info-title"></span>
            <div class="text">
                <span><tv k="pm1"/></span>
                <span class="sub-text"><tv k="pm2"/></span>
            </div>
            <span class="status ok"><tv k="pm3"/></span>
        </div>
        <div class="model-line-bg"></div>
        <div class="model-content">
            <div class="name"><tv k="pm4"/></div>
            <div class="play-process">
                <span class="timer"><tv k="pm5"/></span>
                <el-slider v-model="p1" class="process"></el-slider>
                <span class="total"><tv k="pm6"/></span>
            </div>
            <div class="play-ctl">
                <span class="icon icon-player-prev btn"></span>
                <span class="icon icon-player-pause btn"></span>
                <span class="icon icon-player-next btn"></span>
            </div>
            <div class="play-list" name="playlist">
                <div class="sound" v-for="item in t('playlist')" :key="item[0] + item[1]">
                    <span class="sound-name">{{item[0]}}</span>
                    <span class="author">{{item[1]}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "PlayerModel",
        components: {
        },
        data(){
            return {
                p1: 30
            }
        }
    }
</script>

<style lang="less">
    .player {
        .model-content {
            display: flex;
            flex-direction: column;

            .name {
                font-size: 22px;
                letter-spacing: 0px;
                color: #32c5ff;
                text-align: center;
                padding: 10px 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .play-process{
                padding: 0 30px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .timer, .total{
                    font-size: 12px;
                    letter-spacing: 0px;
                    color: #ffffff;
                }
                .process{
                    flex-grow: 1;
                    margin: 0 15px;
                }
            }

            .play-ctl{
                display: flex;
                align-items: center;
                justify-content: center;

                .icon-player-prev, .icon-player-next{
                    width: 22px;
                    height: 22px;
                }

                .icon-player-pause{
                    width: 33px;
                    height: 33px;
                    margin: 0 20px;
                }
            }

            .play-list{
                flex-grow: 1;
                overflow-y: auto;
                font-size: 12px;
                letter-spacing: 0px;
                color: #ffffff;
                padding: 16px;

                .sound {
                    border-top: 1px solid rgba(255, 255, 255, 0.3);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 10px 0;

                    &:last-child{
                        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
                    }
                }
            }
        }
    }

</style>
